module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("Acknowledgments")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("I owe thanks to a number of individuals and institutions for generously helping me in the preparation of this book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In Los Angeles: Stephen Mamber, Mark and Patricia Treadwell, Don and Sue Silver, Richard and Jan Miller, Burt Senkfor, Sam Gill, and the libraries of UCLA, USC, and the Academy of Motion Picture Arts and Sciences.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In New York: Mary Corliss, Museum of Modern Art/Film Stills Archive, Performing Arts Research Center of New York Public Library.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In Madison, Wisconsin: Tino Balio, Harry Miller, Wisconsin Center for Film and Theater Research.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In Bozeman, Montana: Paul Monaco.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In Washington, D.C.: Library of Congress.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In Maryland: Sheryl Williams, Beverly Lorenz, Kosta Kostadinov, Greg Faller, Barry Moore, Steve Weiss, Maria Saccone, Bill Horne, Ron Matlon, Gloria Gaguski, Gilbert Brungardt, Annette Chappell, Gary Edgerton, Bob Kolker, Video Americain, Marcella Fultz, Susan Mower, Marc Sober, Roger Lewin, Joan Lewin, Yvonne Lev, Sara Lev, and the libraries of Towson State University, Johns Hopkins University, University of Maryland Baltimore County, University of Maryland College Park, and Enoch Pratt Free Library.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Special thanks to Provost Robert Caret, Dean Esslinger, and the Faculty Research and Faculty Development Committees of Towson State University for their financial support of my research.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Special thanks as well to my editors, Tom Schatz of the University of Texas and Frankie Westbrook of U.T. Press.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An earlier version of Chapter 6, “Art and Commerce in "), _c('i', [_vm._v("Contempt")]), _vm._v(",” appeared in "), _c('i', [_vm._v("New Orleans Review")]), _vm._v(" 15, no. 3 (Fall, 1988). Reprinted by permission of the "), _c('i', [_vm._v("New Orleans Review")]), _vm._v(", © 1988. An earlier version of Chapter 7, "), _c('i', [_vm._v("“Blow-Up")]), _vm._v(", Swinging London, and the Film Generation,” was originally published by "), _c('i', [_vm._v("Literature/Film Quarterly")]), _vm._v(", Vol. 17, No. 2, © Salisbury State University, Md. (1989). Reprinted by permission.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8bb6ca3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/07_Acknowledge.vue
// module id = 75
// module chunks = 0